import { cn } from "@ibada/ui"

import { useTranslations } from "@/i18n"
import { ReportCatalogGroup, reportCatalogTabLabelKey } from "@/features/reports/model/report-catalog-tab"

/**
 * One colour per group, so a long list reads by family at a glance. Colour is never the only key: the tag
 * also names the group.
 */
const GROUP_TAG_CLASS: Record<ReportCatalogGroup, string> = {
  [ReportCatalogGroup.Finance]: "bg-teal-50 text-teal-700 dark:bg-teal-950/50 dark:text-teal-300",
  [ReportCatalogGroup.Funds]: "bg-orange-50 text-orange-700 dark:bg-orange-950/50 dark:text-orange-300",
  [ReportCatalogGroup.Members]: "bg-violet-50 text-violet-700 dark:bg-violet-950/50 dark:text-violet-300",
  [ReportCatalogGroup.Activities]: "bg-indigo-50 text-indigo-700 dark:bg-indigo-950/50 dark:text-indigo-300",
  [ReportCatalogGroup.Accounting]: "bg-muted text-muted-foreground",
}

export function ReportGroupTag({ group, className }: { group: ReportCatalogGroup; className?: string }) {
  const t = useTranslations()
  return (
    <span
      data-testid='report-group-tag'
      data-group={group}
      className={cn(
        "inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-[11.5px] font-bold whitespace-nowrap",
        GROUP_TAG_CLASS[group],
        className,
      )}
    >
      {t(reportCatalogTabLabelKey(group) as never)}
    </span>
  )
}
